<div *ngIf="!isOTPRequired" class="flex justify-center items-center w-full h-full font-poppins transform translate-x-full animate-slideIn">
  <div class="flex justify-center items-center w-full h-full relative">
    <svg xmlns="http://www.w3.org/2000/svg" width="321" height="317" viewBox="0 0 321 317" fill="none" class="opacity-80 z-10">
      <path d="M320 1H1V316H5.20844H187.855L320 171.816V1Z" fill="url(#paint0_linear_1_13)" fill-opacity="1" stroke="white" />
      <defs>
        <linearGradient id="paint0_linear_1_13" x1="160.5" y1="64.7975" x2="160.5" y2="316" gradientUnits="userSpaceOnUse">
          <stop stop-color="#1D2555" />
          <stop offset="1" stop-color="#05050C" />
        </linearGradient>
      </defs>
    </svg>

    <div class="absolute top-[20%] flex justify-center items-center w-full z-20">
      <form class="flex flex-col justify-center items-center" (ngSubmit)="login()">
        <div class="flex flex-col text-center space-y-2">
          <input type="email" [(ngModel)]="email" name="email" placeholder="Enter email here" class="bg-transparent text-white border-b-2 border-white outline-none p-1 w-64 mb-2" />

          <div class="flex justify-between items-center border-b-2 border-white p-1 w-64">
            <input type="password" [(ngModel)]="password" name="password" placeholder="Enter password here" class="bg-transparent text-white outline-none w-full" #passwordInput />
            <button type="button" (click)="togglePasswordVisibility(passwordInput)" class="text-white">
              <i *ngIf="!showPassword" class="fas fa-eye-slash"></i>
              <i *ngIf="showPassword" class="fas fa-eye"></i>
            </button>
          </div>

          <div class="text-right text-sm text-blue-400">
            <button type="button" (click)="navigateToForgotPassword()">Forgot Password?</button>
          </div>
        </div>

        <div class="flex w-full flex-col">
          <button
            type="submit"
            class="relative mt-3 h-12 w-64 bg-[#31a1f6] text-white font-poppins transform translate-x-[-2.5rem] translate-y-6 overflow-hidden hover:text-[#31a1f6] transition-colors duration-300 group">
            Login
            <span
              class="absolute top-0 left-0 h-full w-0 bg-white transition-all duration-300 group-hover:w-full z-[-1]"></span>
          </button>
          <button
          (click)="navigateToRegister()"
            class="relative mt-3 text-[13px] w-64  text-white font-poppins transform translate-x-[-3rem] translate-y-5  overflow-hidden group">
            Create account? <span class="text-[#31a1f6] hover:text-blue-600 transition-colors duration-300">Register here</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<div *ngIf="isOTPRequired" class="w-full h-full flex justify-center items-center">
  <app-enter-otp [isForgotPasswordComponent]="false" [email]="this.email"> </app-enter-otp>
</div>
